import React from "react";

// A sheet cell is normally a plain string, but the backend sends
// {text, url} when the cell is actually a hyperlink (rich-text link or a
// =HYPERLINK(...) formula), so it can render as a real clickable link.
const CellValue = ({ value }) => {
  if (value && typeof value === "object" && value.url) {
    return (
      <a
        href={value.url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-qcyan underline underline-offset-2 hover:text-qcyan/80"
      >
        {value.text || value.url}
      </a>
    );
  }
  return <>{value}</>;
};

export default CellValue;
